import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
function PrivacyContent() {
  return <div className="space-y-6 text-sm font-light" data-id="element-23">
      <p className="text-xs uppercase tracking-widest" style={{
      color: '#8FAF88'
    }} data-id="element-24">
        Last updated: 2025
      </p>

      <section className="space-y-3" data-id="element-25">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-26">
          1. Information We Collect
        </h3>
        <p data-id="element-27">
          When you purchase The Complete Wedding Planner, we collect only the
          information necessary to process your transaction — including your
          name and email address. We do not collect sensitive personal data
          beyond what is required for delivery of your digital product.
        </p>
      </section>

      <section className="space-y-3" data-id="element-28">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-29">
          2. How We Use Your Information
        </h3>
        <p data-id="element-30">Your information is used solely to:</p>
        <ul className="space-y-2 pl-4" data-id="element-31">
          <li className="flex items-start gap-2" data-id="element-32">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-33">
              —
            </span>{' '}
            Deliver your digital download
          </li>
          <li className="flex items-start gap-2" data-id="element-34">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-35">
              —
            </span>{' '}
            Send your purchase confirmation
          </li>
          <li className="flex items-start gap-2" data-id="element-36">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-37">
              —
            </span>{' '}
            Provide customer support if needed
          </li>
        </ul>
        <p data-id="element-38">
          We will never sell, rent, or share your personal information with
          third parties for marketing purposes.
        </p>
      </section>

      <section className="space-y-3" data-id="element-39">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-40">
          3. Digital Product Delivery
        </h3>
        <p data-id="element-41">
          Upon purchase, you will receive an email with a secure download link.
          This link is personal to you and should not be shared. Sage Script is
          not responsible for lost access due to shared or expired links.
        </p>
      </section>

      <section className="space-y-3" data-id="element-42">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-43">
          4. Cookies
        </h3>
        <p data-id="element-44">
          This website may use minimal cookies to improve your browsing
          experience. These cookies do not store personally identifiable
          information and are used only for basic site functionality.
        </p>
      </section>

      <section className="space-y-3" data-id="element-45">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-46">
          5. Data Security
        </h3>
        <p data-id="element-47">
          We take reasonable precautions to protect your information. All
          transactions are processed through secure, encrypted payment
          providers. We do not store your payment details.
        </p>
      </section>

      <section className="space-y-3" data-id="element-48">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-49">
          6. Your Rights
        </h3>
        <p data-id="element-50">
          You have the right to request access to, correction of, or deletion of
          any personal data we hold about you. As we collect minimal data, most
          requests can be fulfilled promptly.
        </p>
      </section>

      <section className="space-y-3" data-id="element-51">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-52">
          7. Changes to This Policy
        </h3>
        <p data-id="element-53">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page with an updated date.
        </p>
      </section>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6 text-sm font-light" data-id="element-54">
      <p className="text-xs uppercase tracking-widest" style={{
      color: '#8FAF88'
    }} data-id="element-55">
        Last updated: 2025
      </p>

      <section className="space-y-3" data-id="element-56">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-57">
          1. Digital Product
        </h3>
        <p data-id="element-58">
          The Complete Wedding Planner by Sage Script is a digital product
          delivered via instant download. No physical item will be shipped. By
          completing your purchase, you acknowledge that you are purchasing a
          non-tangible digital good.
        </p>
      </section>

      <section className="space-y-3" data-id="element-59">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-60">
          2. No Refund Policy
        </h3>
        <p data-id="element-61">
          Due to the instant-access nature of digital products, all sales are
          final. We do not offer refunds once the download link has been
          delivered. Please review the product description carefully before
          purchasing.
        </p>
      </section>

      <section className="space-y-3" data-id="element-62">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-63">
          3. License & Personal Use
        </h3>
        <p data-id="element-64">
          Upon purchase, you are granted a single-user, non-transferable license
          to use The Complete Wedding Planner for your own personal planning
          purposes. You may not:
        </p>
        <ul className="space-y-2 pl-4" data-id="element-65">
          <li className="flex items-start gap-2" data-id="element-66">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-67">
              —
            </span>{' '}
            Resell, redistribute, or share the file
          </li>
          <li className="flex items-start gap-2" data-id="element-68">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-69">
              —
            </span>{' '}
            Claim the design as your own
          </li>
          <li className="flex items-start gap-2" data-id="element-70">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-71">
              —
            </span>{' '}
            Use it for commercial purposes
          </li>
          <li className="flex items-start gap-2" data-id="element-72">
            <span style={{
            color: '#8FAF88'
          }} data-id="element-73">
              —
            </span>{' '}
            Upload it to any file-sharing platform
          </li>
        </ul>
      </section>

      <section className="space-y-3" data-id="element-74">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-75">
          4. Compatibility
        </h3>
        <p data-id="element-76">
          This planner is designed for use with GoodNotes and Notability on
          iPad. Sage Script does not guarantee compatibility with all apps or
          devices. It is your responsibility to ensure compatibility before
          purchasing.
        </p>
      </section>

      <section className="space-y-3" data-id="element-77">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-78">
          5. Intellectual Property
        </h3>
        <p data-id="element-79">
          All content, design, and layout of The Complete Wedding Planner is the
          intellectual property of Sage Script. Unauthorized reproduction or
          distribution is strictly prohibited and may result in legal action.
        </p>
      </section>

      <section className="space-y-3" data-id="element-80">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-81">
          6. Limitation of Liability
        </h3>
        <p data-id="element-82">
          Sage Script is not liable for any indirect, incidental, or
          consequential damages arising from the use or inability to use this
          digital product. Our total liability shall not exceed the amount paid
          for the product.
        </p>
      </section>

      <section className="space-y-3" data-id="element-83">
        <h3 className="text-lg font-serif" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-84">
          7. Governing Law
        </h3>
        <p data-id="element-85">
          These terms are governed by applicable law. By purchasing, you agree
          to these terms in full.
        </p>
      </section>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-10 px-6 text-center border-t" style={{
      backgroundColor: '#8FAF88',
      borderColor: 'rgba(255,255,255,0.15)'
    }} data-id="element-86">
        <p className="text-xs uppercase tracking-widest mb-4" style={{
        color: 'rgba(255,255,255,0.5)',
        fontFamily: "'Jost', sans-serif"
      }} data-id="element-87">
          © {new Date().getFullYear()} Sage Script. All rights reserved.
        </p>
        <div className="flex items-center justify-center gap-6" data-id="element-88">
          <button onClick={() => setPrivacyOpen(true)} className="text-xs uppercase tracking-widest transition-opacity duration-200 hover:opacity-100" style={{
          color: 'rgba(255,255,255,0.65)',
          fontFamily: "'Jost', sans-serif"
        }} data-id="element-89">
            Privacy Policy
          </button>
          <span style={{
          color: 'rgba(255,255,255,0.25)'
        }} data-id="element-90">
            ·
          </span>
          <button onClick={() => setTermsOpen(true)} className="text-xs uppercase tracking-widest transition-opacity duration-200 hover:opacity-100" style={{
          color: 'rgba(255,255,255,0.65)',
          fontFamily: "'Jost', sans-serif"
        }} data-id="element-91">
            Terms of Service
          </button>
        </div>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Privacy Policy" data-id="element-92">
        <PrivacyContent data-id="element-93" />
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Terms of Service" data-id="element-94">
        <TermsContent data-id="element-95" />
      </LegalModal>
    </>;
}